import TwoFactorContainer from "../../../../Component/Forms/FormsLayout/TwoFactor/TwoFactor"

const TwoFactor = () => {
  return (
    <div className='page-body'>
      <TwoFactorContainer />
    </div>
  )
}

export default TwoFactor